<template>

  <!--Drawer-->
  <v-navigation-drawer app v-model="drawer">

    <!-- Avatar -->
    <v-container v-if="isLoggedIn" class="px-4">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-avatar size="100">
            <v-img :src="avatarUrl"></v-img>
          </v-avatar>
          <div class="font-weight-bold text-green-darken-4">
            {{ firstName }} {{ lastName }} ({{ role }})
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--Links-->
    <v-list lines="two">
      <v-list-item
        v-for="link in filteredLinks"
        :to="link.to"
        :key="link.key"
        :title="$t(link.key)"
      >
        <template v-slot:prepend>
          <v-icon>{{link.icon}}</v-icon>
        </template>
      </v-list-item>      

      <v-divider class="my-2"></v-divider>

      <v-list-item
        prepend-icon="mdi-logout"
        :title="$t('nav.sign_out')"
        @click="signAction"
      />
    </v-list>

  </v-navigation-drawer>


  <!--App bar-->
  <v-app-bar>
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>

    <div class="d-flex align-center ga-2 text-h5 font-weight-bold">
      <HeadIcon height="28" />
      <span class="text-primary" style="font-family: 'Fraunces', Georgia, serif;">Resonaro</span>
    </div>

    <v-spacer></v-spacer>
    
    <v-btn @click="toggleDarkTheme" icon>
      <v-icon>{{ isDark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent' }}</v-icon>
    </v-btn>

  </v-app-bar >


</template>

<script>
import { useTheme } from 'vuetify'
import { appStore } from '@/stores/AppStore'
import apiService from '@/services/ApiService'
import HeadIcon from '@/components/public/HeadIcon.vue'

export default {
  name: 'UserNavBar',
  components: { HeadIcon },

  data() {
    return {
      drawer: false,
      links: [
        // { title: 'Welcome', icon: 'mdi-home', to: '/', "protected": false },
        { key: 'nav.matches', icon: 'mdi-format-list-bulleted', to: '/matches', "protected": true },
        { key: 'nav.me',      icon: 'mdi-account',              to: '/me',      "protected": true },
        // { title: 'Clients', icon: 'mdi-account-multiple', to: '/psychologist/clients', "protected": true  },        
        // { title: 'About', icon: 'mdi-information', to: '/about', "protected": false  },        
        // { title: 'Evaluations', icon: 'mdi-clipboard-text', to: '/user/evaluations', "protected": true  },        
        // { title: 'Logout', icon: 'mdi-login', to: '/login',"protected": true  },
      ],
      store: appStore(),
    }
  },  

  created() {
    this.theme = useTheme()
  },

  mounted() {
    // this.store.initAuth();
  },

  computed: {
    filteredLinks() {
      return this.links.filter(link => {
        if (link.protected && !this.store.isLoggedIn) {
          return false;
        }
        return true;
      });
    },

    isLoggedIn() {
      return this.store.isLoggedIn;
    },

    firstName() {
      return this.store.user?.firstName || '';
    },

    lastName() {
      return this.store.user?.lastName || '';
    },  

    role() {
      return this.store.user?.role || 'guest';
    },

    avatarUrl() {
      return this.store.user?.avatarUrl || '/images/logo.png';
    },

    isDark() {
      return this.store.darkTheme  // Read directly from store
    }, 
  },

  methods: {
    signAction() {
      if (this.isLoggedIn) {
        this.store.logout();
        apiService.clearToken()
        this.$router.push('/login');
      } else {
        this.$router.push('/login');
      }
    },

    toggleDarkTheme() {
      this.store.setDarkTheme(!this.store.darkTheme);
    },
  }
}
</script>

<style scoped>
/**This forces the text not to be shrunk*/
.full-title{
  flex: none;
}
</style>